const $$splitComponentImporter = () => import('/src/src/routes/(compatibility)/onboarding.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

/**
 * Redirect old onboarding links to new enrollment route
 *
 * @deprecated
 */
export const Route = createFileRoute("/(compatibility)/onboarding")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});